import React from 'react';
import hand from '../Assets/hand.png';

const SoftSkills = () => {
  return (
    <div className='soft-container'>
      <h1 className='skill'>Soft Skills</h1>
      <div className='container-soft'>
        <div className='soft-list'>
          <img src={hand} alt="icon" className='icon-hand' />
        </div>
        <ul className='skills-list'>
          <li className='li-skills'>Inciative</li>
          <li className='li-skills'>Organization</li>
          <li className='li-skills'>Planning Team</li>
          <li className='li-skills'>Collaboration</li>
          <li className='li-skills'>Growth</li>
          <li className='li-skills'>Self-study</li>
          <li className='li-skills'>Mindset Time</li>
          <li className='li-skills'>Management</li>
          <li className='li-skills'>Self-discipline</li>
        </ul>
      </div>
    </div>
  );
}

export default SoftSkills;
